(function () {
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var modal = document.querySelector('modal-dialog.article-upsell-modal');
    if (!modal) return;

    var handle = modal.dataset.articleHandle || 'article';
    var storageKey = 'upsell_dismissed_' + handle;

    var dismissed = false;
    try {
      dismissed = sessionStorage.getItem(storageKey) === '1';
    } catch (e) { /* private mode etc — proceed without persistence */ }

    function markDismissed() {
      dismissed = true;
      try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
    }

    // Subscribe to cart updates so an ATC from EITHER inline or modal closes the modal
    // and prevents re-trigger this session. PUB_SUB_EVENTS / subscribe come from pubsub.js + constants.js.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (!payload || payload.source !== 'product-form') return;
        var formId = (document.activeElement && document.activeElement.form && document.activeElement.form.id) || '';
        var fromUpsell = formId.indexOf('ArticleUpsell') === 0;
        // Even if focus moved, if either upsell form exists in the DOM and the cart fired during this article view, mark dismissed.
        // We err toward dismissing since the surfaces are the only ATCs on this page.
        if (fromUpsell || document.querySelector('[id^="ArticleUpsellModalForm-"], [id^="ArticleUpsellInlineForm-"]')) {
          markDismissed();
          if (modal.hasAttribute('open')) modal.hide();
        }
      });
    }

    // Dismiss button — already wired by ModalDialog (matches [id^="ModalClose-"]),
    // but we also want to record the session flag.
    var closeBtn = modal.querySelector('[data-upsell-dismiss]');
    if (closeBtn) {
      closeBtn.addEventListener('click', markDismissed);
    }

    if (dismissed) return;

    var contentEl = document.querySelector('.article-template__content');
    if (!contentEl) return;

    var THRESHOLD = 0.25; // fire when reader is 25% through the article body
    var triggered = false;
    var ticking = false;

    function check() {
      ticking = false;
      if (triggered || dismissed) return;
      var rect = contentEl.getBoundingClientRect();
      var contentTop = rect.top + window.scrollY;
      var contentHeight = contentEl.offsetHeight;
      var viewport = window.innerHeight;
      // Scrollable distance through the content; floor at 1 so short articles still fire.
      var scrollable = Math.max(1, contentHeight - viewport);
      var progress = (window.scrollY - contentTop) / scrollable;
      // Short-content fallback: if content fits entirely above the fold, treat reaching
      // its midpoint as "30% in".
      if (contentHeight <= viewport) {
        progress = (window.scrollY + viewport * 0.5 - contentTop) / contentHeight;
      }
      if (progress >= THRESHOLD) {
        triggered = true;
        window.removeEventListener('scroll', onScroll);
        if (typeof modal.show === 'function') modal.show();
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    check(); // handle case where the user lands already past 30% (e.g. anchor link)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
